import React from 'react'
import PresentacionesAccordion from './components/PresentacionesAccordion'
import { PresentacionProvider } from './context/presentacion.context'
import '../shared/components/button/buttonDemo.scss'

const CargarPresentacion = () => {

  return (
      <PresentacionProvider>
          <PresentacionesAccordion/>
      </PresentacionProvider>
  )
}

export default CargarPresentacion